<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Oa5uES/tc-custom/9781429997232.jpg?1737768515847" alt="This image is the cover for the book Body Snatchers Affair, The Carpenter and Quincannon Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Body Snatchers Affair, The Carpenter and Quincannon Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p><i>The Body Snatchers Affair: </i>The latest in the Carpenter and Quincannon historical mystery series from Marcia Muller and Bill Pronzini.<br/><br/>Two missing bodies and two separate investigations take Carpenter and Quincannon from the heights above San Francisco Bay to the depths of Chinatown's opium dens. <br/><br/>For John Quincannon, this is a first: searching a Chinatown opium den for his client's husband, missing in the middle of a brewing tong war set to ignite over the stolen corpse of Bing Ah Kee.<br/><br/>Meanwhile, his partner, Sabina Carpenter, unsure of the dark secrets her suitor might be concealing, searches for the corpse of a millionaire, stolen from a sealed family crypt and currently being held for ransom. <br/><br/>With the threat of a tong war hanging over the city (a war perhaps being spurred on by corrupt officials), Carpenter and Quincannon have no time to lose in solving their cases. Is there a connection between the two body snatchers? Or is simple greed the answer to this one?<br/><br/>And why is the enigmatic Englishman who calls himself Sherlock Holmes watching so carefully from the shadows?<br/><br/><b>The Carpenter and Quincannon Mysteries:</b><br/>#1 <i>The Bughouse Affair</i><br/>#2 <i>The Spook Lights Affair</i><br/>#3 <i>The Body Snatchers Affair</i><br/>#4 <i>The Plague of Thieves Affair</i><br/>#5<i> The Dangerous Ladies Affair</i><br/>#6 <i>The Bags of Tricks Affair</i><br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marcia Muller, Bill Pronzini
      </h2>
      
      <p class="authorDescription body article"><P><B>MARCIA MULLER</B> is the <I>New York Times </I>bestselling creator of private investigator Sharon McCone. The author of more than thirty-five novels, Muller received the Mystery Writers of America's Grand Master Award in 2005. She lives in northern California with her husband, the crime novelist Bill Pronzini.<br><br><B>BILL PRONZINI</B>'s novel <I>Snowbound</I> received the Grand Prix de la Littérature Policière as the best crime novel published in France in 1988. <I>A Wasteland of Strangers</I> was nominated for best crime novel of 1997 by both the Mystery Writers of America and the International Crime Writers Association. In addition to six Edgar Award nominations and one win for <I>A Wasteland of Strangers</I>, Pronzini has received three Shamus Awards, two for best novel and the Lifetime Achievement Award. He is also the author of the Nameless Detective novels, the longest-running private investigator series currently in print, which includes the award-winning entries <I>Hoodwink</I> and <I>Boobytrap</I>. He lives in northern California with his wife, the crime novelist Marcia Muller.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?96100a14